// Sample page: https://golddogstudios.photoshelter.com
import Typography from '../components/Typography';
import Flex from '../components/Flex';
import Link from '../components/Link';
import albums from '../Albums.json';
import { ImageList, ImageListItem } from '@mui/material';


const Home = () => (
    <ImageList cols={3} gap={8}>
    {albums.map(({hidden, title, s3Bucket, cover}) => hidden ? (null) : (
      <ImageListItem key={title}>
        <Link href={`/album/${s3Bucket}`} key={s3Bucket}>
          <Flex key={s3Bucket} textAlign="center" flexDirection="column" alignItems="center">
            <img src={cover} alt={title} style={{height: '200px'}}/>
            {title.split('\n').map((text, i) => (
              <Typography key={title+i}>
                {text}
              </Typography>
            ))}
          </Flex>
        </Link>
      </ImageListItem>
    ))}
    </ImageList>
)

export default Home
